enum EButtonSize {
    regular = 'regular',
    small = 'small',
};

export default EButtonSize;